import { Typography } from '@mui/material';
import styles from '@src/main/ui/components/common/ErrorPage/ErrorPage.module.scss';
import type React from 'react';
import { useRouteError } from 'react-router-dom';

export const ErrorPage: React.FC = () => {
  const error = useRouteError() as { message: string };
  const errorDescription = 'There was an error during the request. Please, try again.';
  const authErrorDescription = 'Failed to acquire token';
  const isAuthError = error.message === 'Failed to acquire token';
  return (
    <div className={styles.errorPage}>
      <Typography variant="h3">Oops! :(</Typography>
      <Typography className={styles.errorPage__subtitle}>
        {isAuthError ? authErrorDescription : errorDescription}
      </Typography>
    </div>
  );
};
